import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Constraints } from '../../constraints/index.js';
import { jsx } from '@emotion/react';
import mergeDefaultProps from '../../../utils/merge-default-props.js';
import useFieldId from '../../../hooks/use-field-id/use-field-id.js';
import { PasswordInput } from '../../inputs/password-input/password-input.js';
import { FieldMessage } from '../../field-message/field-message.js';
import createSequentialId from '../../../utils/create-sequential-id.js';
import { Stack } from '../../spacings/stack/stack.js';
import { Inline } from '../../spacings/inline/inline.js';
import { FieldLabel } from '../../field-label/field-label.js';

var _excluded = ["description", "error", "helpText", "hint", "hintPosition", "horizontalConstraint", "isPasswordVisible", "leftIcon", "optionalText", "size", "title", "touched", "warning"];
var sequentialId = createSequentialId('password-field-');
var defaultProps = {
  horizontalConstraint: 'scale',
  size: 'l'
};
var PasswordFieldInternal = function PasswordFieldInternal(props, ref) {
  var propsInternal = mergeDefaultProps(props, defaultProps);
  var description = propsInternal.description,
      error = propsInternal.error,
      helpText = propsInternal.helpText,
      hint = propsInternal.hint,
      hintPosition = propsInternal.hintPosition,
      horizontalConstraint = propsInternal.horizontalConstraint,
      isPasswordVisible = propsInternal.isPasswordVisible,
      leftIcon = propsInternal.leftIcon,
      optionalText = propsInternal.optionalText,
      size = propsInternal.size,
      title = propsInternal.title,
      touched = propsInternal.touched,
      warning = propsInternal.warning,
      rest = _objectWithoutProperties(propsInternal, _excluded);
  var id = useFieldId(rest.id || '', sequentialId);
  var showError = touched && !!error && error.length > 0;
  var showWarning = touched && !showError && !!warning && warning.length > 0;
  return jsx(Constraints.Horizontal, {
    constraint: horizontalConstraint
  }, jsx(Stack, {
    scale: "xs"
  }, jsx(Inline, {
    alignItems: "flex-end",
    justifyContent: "space-between"
  }, jsx(FieldLabel, {
    description: description,
    hint: hint,
    hintPosition: hintPosition,
    htmlFor: id,
    optionalText: optionalText,
    title: title
  })), jsx(PasswordInput, _extends({
    ref: ref,
    hasError: showError,
    hasWarning: showWarning,
    horizontalConstraint: "scale",
    id: id,
    isPasswordVisible: isPasswordVisible,
    leftIcon: leftIcon,
    size: size
  }, rest)), jsx(FieldMessage, {
    error: error,
    helpText: helpText,
    isVisible: touched,
    warning: warning
  })));
};
PasswordFieldInternal.displayName = 'PasswordField';
var PasswordField = React.forwardRef(PasswordFieldInternal);

export { PasswordField };
//# sourceMappingURL=password-field.js.map
